export default __webpack_public_path__ + "static/media/chevron.2f4ad2d6.svg";